module.exports = __webpack_public_path__ + "img/290.33e49ba7.svg";